import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import { connect } from 'react-redux';
import { v4 } from 'node-uuid';
import RaisedButton  from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
var MaskedInput = require('react-maskedinput');
import { red600 } from 'material-ui/styles/colors';

const Row = props => {
  const { percent, type, val, handlePaymentTypeChange, handlePaymentDateChange, handlePaymentDaysChange, handlePercentChange, index } = props;
  const labelStyle = {
    fontSize: '12px',
    padding: '6px',
  }

  return (
    <div style={{display: 'flex'}}>
      <div style={{display: 'flex'}}>
        <div style={{width: '100px', padding: '8px'}}>
          <TextField
            id={v4()}
            style={{width: '100%'}}
            underlineFocusStyle={{borderColor: red600 }}
            placeholder='Процент'
            value={percent || ''}
            onChange={
              e => {
                handlePercentChange(e.target.value, index)
              }
            }
          />
        </div>
        <div style={{display: 'flex', alignItems: 'center'}}>
          <FlatButton
            label='Дата'
            labelStyle={labelStyle}
            style={{marginLeft: '1px'}}
            backgroundColor={type === 'date' ? '#eee' : 'initial'}
            onClick={
              () => {
                handlePaymentTypeChange('date', index)
              }
            }
          />
          <FlatButton
            label='Дней после отгрузки'
            labelStyle={labelStyle}
            style={{marginLeft: '1px'}}
            backgroundColor={type === 'days' ? '#eee' : 'initial'}
            onClick={
              () => {
                handlePaymentTypeChange('days', index)
              }
            }
          />
        </div>
        <div style={{width: '120px', padding: '8px'}}>
          <TextField
            id={v4()}
            style={{width: '100%'}}
            underlineFocusStyle={{borderColor: red600 }}
          >
            { type === 'date' ?
              <MaskedInput
                mask="11.11.2011"
                name="expiry"
                placeholder="dd.mm.yyyy"
                value={val}
                onChange={
                  e => {
                    handlePaymentDateChange(e.target.value, index);
                  }
                }
              />
              :
              <MaskedInput
                mask="11"
                name="expiry"
                placeholder="дней"
                onChange={
                  e => {
                    handlePaymentDaysChange(e.target.value, index);
                  }
                }
              />
            }
          </TextField>
        </div>
      </div>
    </div>
  )
}

const PaymentConditions = props => {
  const { paymentToggle, paymentConditionsState, saveConditions, rowsQty, handleAddRows, valid, warnings, ...other } = props;
  return (
    <div style={{display: 'flex, flexDirection: column'}}>
      <RaisedButton
        label='ОК'
        style={{ marginBottom: '16px' }}
        onClick={saveConditions}
        disabled={!valid}
      />
      <RaisedButton
        label='Отмена'
        style={{ marginBottom: '16px', marginLeft: '12px' }}
        onClick={paymentToggle}
      />
      {warnings}
      {
        paymentConditionsState.map( (elem, i) => {
          return i>= rowsQty ? null : <Row key={i} {...elem} {...other} index={i} />;
        })
      }
      {rowsQty === 5 &&
        <FlatButton
          label='Добавить строки'
          onClick={handleAddRows}
        />
      }
    </div>
  );
};

class PaymentConditionsContainer extends Component {

  constructor(props) {
    super(props);
    this.state = { paymentConditions: props.paymentConditions, rowsQty: 5, conditionsValid: true, warnings: [], valid: false };
  }

  componentDidMount() {
    this.validate();
  }

  componentWillReceiveProps(){
    this.validate();
  }

  validate = () => {
    let valid = true;
    let warnings = [];
    const { paymentConditions } = this.state;
    // validate total sum
    const sum = paymentConditions.reduce((res, val) => res + val.percent , 0);
    if (sum !== 100) {
      valid = false;
      warnings.push(<div key={'sumWarning'} style={{color: 'red', fontSize: '14px'}}>Общая сумма процентов по всем строкам должна быть равна 100</div>);
    }
    //validate every rowsQty
    paymentConditions.reduce((res, val, i ) => {
      if (val.percent === 0)
        return res;
      let elem;
      if (val.type === 'date') {
        elem = val.val === '' || val.val === 0 ? <div key={`warning${i}`} style={{color: 'red', fontSize: '14px'}}>{`В строке ${i+1} не задана дата поставки`}</div> : undefined;
      } else {
        elem = val.val === '' || val.val === 0 ? <div key={`warning${i}`} style={{color: 'red', fontSize: '14px'}}>{`В строке ${i+1} не задано количество дней`}</div> : undefined;
      }
      elem !== undefined && res.push(elem);
      if (elem !== undefined)
        valid = false;
      return res;
    }, warnings);
    this.setState({ valid, warnings });
  }

  handlePaymentDateChange = (val, index) => {
    const paymentConditions = [...this.state.paymentConditions];
    paymentConditions[index].val = val;
    this.setState({ paymentConditions }, this.validate)
  }

  handlePaymentDaysChange = (val, index) => {
    const paymentConditions = [...this.state.paymentConditions];
    paymentConditions[index].val = parseInt(val, 10) || 0;
    this.setState({ paymentConditions }, this.validate)
  }

  handlePercentChange = (val, index) => {
    const paymentConditions = [...this.state.paymentConditions];
    paymentConditions[index].percent = parseInt(val, 10) || 0;
    this.setState({ paymentConditions }, this.validate)
  }

  handlePaymentTypeChange = (val, index) => {
    const paymentConditions = [...this.state.paymentConditions];
    paymentConditions[index].type = val;
    this.setState({ paymentConditions }, this.validate)
  }

  saveConditions = () => {
    this.props.dispatch({
      type: 'SET_PAYMENT_CONDITIONS',
      p: this.state.paymentConditions
    });
    this.props.paymentToggle();
  }

  handleAddRows = () => {
    this.setState({ rowsQty: 10 });
  }

  render() {
    const actions = {
      handlePaymentDateChange: this.handlePaymentDateChange,
      handlePaymentDaysChange: this.handlePaymentDaysChange,
      handlePercentChange: this.handlePercentChange,
      handlePaymentTypeChange: this.handlePaymentTypeChange,
      saveConditions: this.saveConditions,
      handleAddRows: this.handleAddRows
    };
    return (<PaymentConditions {...this.props} {...actions} paymentConditionsState={this.state.paymentConditions} rowsQty={this.state.rowsQty} valid={this.state.valid} warnings={this.state.warnings} />);
  }

}

export default connect(
  state => ({ paymentConditions: state.ui.orderConditions.paymentConditions })
)(PaymentConditionsContainer);



// WEBPACK FOOTER //
// ./src/components/layout/content/prepare-order/payment-conditions.js